<template>
  <div class="game_version_mb">
    <Menu :cg-info="cgInfo" />
    <div class="main_wrap">
      <div class="mb_head_2k">
        <div class="head_btn_wrap">
          <a class="head_dl_btn" :href="dl_link"></a>
          <a
            class="head_by_btn"
            href="https://uc.todesk.com/mobile/orderManage/buyOrder?spuId=100&orderType=0&chargeType=5"
          ></a>
        </div>
        <div class="block_2k_wrap">
          <div class="block_2k_title"></div>
          <p class="block_2k_desc">
            游戏版144帧暂时仅支持电脑远控电脑（Windows系统）且主、被控端都需要升级到v4.7.0.1及以上版本
          </p>
          <div class="block_2k_pic_wrap">
            <div ref="lineTrans" class="trans_line">
              <img
                class="line_img"
                src="https://todeskcdnspeed.todesk.com/202305041601215fad993fb34234.png"
                alt=""
                draggable="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mb_3d_wrap">
        <div class="block_3d_title"></div>
        <p class="block_3d_desc">
          沿用最新的SD-WAN算法技术，并搭载3D鼠标以及手柄映射功能，远程游玩3A大作无压力
        </p>
        <div class="vdo_vs_wrap" ref="vdo_vs_wrap">
          <div class="vdo_other_wrap">
            <video
              @canplay="otherLoad"
              @play="ohterPlaying = true"
              muted
              loop
              ref="vdo_other"
              poster="https://todeskcdnspeed.todesk.com/202305051122135fae9cb9c5dcc4.png"
            >
              <source
                src="https://todeskcdnspeed.todesk.com/a/todesk2.mp4"
                type="video/mp4"
              />
              您的浏览器不支持Video标签。
            </video>
            <p>同类产品</p>
          </div>
          <div class="vdo_todesk_wrap">
            <video
              @canplay="todeskLoad"
              @play="todeskPlaying = true"
              muted
              loop
              ref="vdo_todesk"
              poster="https://todeskcdnspeed.todesk.com/202305051122265fae9cc5b69118.png"
            >
              <source
                src="https://todeskcdnspeed.todesk.com/a/todesk1.mp4"
                type="video/mp4"
              />
              您的浏览器不支持Video标签。
            </video>
            <p>ToDesk</p>
          </div>
          <div class="vdo_vs">
            <img
              src="https://todeskcdnspeed.todesk.com/202304281211185fa5daa41b02f8.png"
              alt=""
              draggable="false"
            />
          </div>
        </div>
        <div class="block_desc_warp">
          <div class="mouse_wrap">
            <div class="bg_wrap">
              <p class="desc_title">适配3D游戏视觉</p>
              <p class="desc_text">
                启用【3D鼠标】功能，远程3D游戏时能更流畅的转动游戏视觉，最大化还原本地操作
              </p>
            </div>
          </div>
          <div class="handler_wrap">
            <div class="bg_wrap">
              <p class="desc_title">支持主流游戏手柄</p>
              <p class="desc_text">
                远程映射PS、XBox手柄，实现手柄远程操控游戏
              </p>
            </div>
          </div>
        </div>
        <div class="block_kb_wrap">
          <div class="block_kb_title"></div>
          <p class="block_kb_desc">为不同游戏提供专属游戏键盘，操作更灵活</p>
          <div class="drop_down_wrap">
            <div
              v-for="(item, dIdx) in dropDownList"
              :key="dIdx"
              :class="[
                'drop_down_item',
                `drop_down_item_${dIdx + 1}`,
                item.active ? 'active' : '',
              ]"
            >
              <div class="drop_down_head" @click="handleChooseTab(dIdx + 1)">
                <p class="dd_label">{{ item.label }}</p>
                <div class="dd_arrow"></div>
              </div>
              <div class="drop_down_img">
                <img :src="item.img" alt="" draggable="false" />
              </div>
            </div>
          </div>
        </div>
        <div class="block_fun_wrap">
          <div class="fun_bg_wrap"></div>
          <div v-for="(item, fIdx) in funList" class="fun_item" :key="fIdx">
            <img class="" :src="item.img" alt="" draggable="false" />
            <p class="fun_title">{{ item.title }}</p>
            <p class="fun_desc">{{ item.desc }}</p>
          </div>
        </div>
        <div class="config_require_wrap">
          <div class="rq_title"></div>
          <div
            v-for="rqItem in configList"
            class="rq_detail_wrap"
            :key="rqItem.label"
          >
            <p class="rq_label">{{ rqItem.label }}</p>
            <div class="rq_text_wrap">
              <p class="rq_text" v-for="text in rqItem.text" :key="text">
                {{ text }}
              </p>
            </div>
          </div>
        </div>
        <div class="gv_dl_wrap">
          <div class="gv_dl_title"></div>
          <p class="dl_desc1">全方位满足您远程游戏的体验，赶紧尝试吧</p>
          <p class="dl_desc2">*移动设备远控pc暂不支持144帧，敬请期待再次升级</p>
          <div class="gv_btn_wrap">
            <a class="head_dl_btn" :href="dl_link"></a>
            <a
              class="head_by_btn"
              href="https://uc.todesk.com/mobile/orderManage/buyOrder?spuId=100&orderType=0&chargeType=5"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import { dealConfig } from "../../utils/util";
export default {
  name: "GameVersionMb",
  components: {
    Menu,
    Footer,
  },
  computed: {
    canPlay() {
      return this.otherLoaded && this.todeskLoaded;
    },
  },
  data() {
    return {
      cgInfo: null,
      currIdx: 1,
      lastIdx: 1,
      otherLoaded: false,
      todeskLoaded: false,
      otherPlaying: false,
      todeskPlaying: false,
      scrollTimer: null,
      dropDownList: [
        {
          label: "英雄联盟",
          img: "https://todeskcdnspeed.todesk.com/202305051141375faea10fb63a00.png",
          active: true,
        },
        {
          label: "绝地求生",
          img: "https://todeskcdnspeed.todesk.com/202305051141525faea11dd81ab8.png",
          active: false,
        },
        {
          label: "云顶之弈",
          img: "https://todeskcdnspeed.todesk.com/202305051141445faea115e6c680.png",
          active: false,
        },
        {
          label: "地下城与勇士",
          img: "https://todeskcdnspeed.todesk.com/202305051142025faea127a5187c.png",
          active: false,
        },
        {
          label: "QQ飞车",
          img: "https://todeskcdnspeed.todesk.com/202305051141305faea108586158.png",
          active: false,
        },
        {
          label: "极品飞车",
          img: "https://todeskcdnspeed.todesk.com/202305051141235faea101a91f14.png",
          active: false,
        },
      ],
      funList: [
        {
          title: "多个键位合而为一",
          desc: "一键“搓大招”，关键时刻Carry全场",
          img: "https://todeskcdnspeed.todesk.com/202305081408395fb28785096ae0.png",
        },
        {
          title: "按键位置随意拖动",
          desc: "自定义按键位置，游戏体验更顺手",
          img: "https://todeskcdnspeed.todesk.com/202305081409035fb2879bdebd6c.png",
        },
        {
          title: "个性调节按键大小",
          desc: "常用按钮放大，误触按钮缩小，大大提高游戏精准度",
          img: "https://todeskcdnspeed.todesk.com/202305081409185fb287aaa10454.png",
        },
        {
          title: "长按/短按自由设定",
          desc: "锁定按键，持续工具，游戏更轻松",
          img: "https://todeskcdnspeed.todesk.com/202305081409365fb287bb31ead0.png",
        },
      ],
      configList: [
        {
          label: "处理器：",
          text: [
            "AMD FX 6300 @ 3.8 GHz, Ryzen 3 - 1200",
            "Intel Core i5 2400 @ 3.1 GHz",
          ],
        },
        {
          label: "内存：",
          text: ["8G"],
        },
        {
          label: "宽带：",
          text: ["上行10M"],
        },
        {
          label: "显示器：",
          text: ["主被控屏幕刷新率均需要144Hz以上"],
        },
      ],
      dl_link: "",
    };
  },
  async created() {
    let u = navigator.userAgent;
    if (u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1) {
      await this.getConfig("ios");
    } else {
      await this.getConfig("android");
    }
  },
  methods: {
    async getConfig(name) {
      try {
        let res = await this.$serve.getConfig({
          type: 1,
          name: name,
        });
        const _res = dealConfig(res.data.list, 1);
        this.dl_link = _res.android_link || _res.ios_link;
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
    handleScroll() {
      const dom = this.$refs.lineTrans;
      let clientHeight = document.documentElement.clientHeight;
      if (dom) {
        const domClientHeight = dom.clientHeight;
        const bdRect = dom.getBoundingClientRect();
        if (
          bdRect.bottom - domClientHeight + 200 < clientHeight &&
          bdRect.bottom >= 0
        ) {
          dom.classList.add("animation");
        }
      }

      if (this.otherPlaying && this.todeskPlaying) return;
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = null;
      }
      this.scrollTimer = setTimeout(() => {
        const clientHeight = document.documentElement.clientHeight;
        const domClientHeight = this.$refs.vdo_vs_wrap.clientHeight;
        const bdRect = this.$refs.vdo_vs_wrap.getBoundingClientRect();
        if (
          bdRect.bottom - domClientHeight < clientHeight &&
          bdRect.bottom >= 0 &&
          this.canPlay
        ) {
          this.$refs.vdo_other?.play();
          this.$refs.vdo_todesk?.play();
          this.otherPlaying = true;
          this.todeskPlaying = true;
        }
      }, 100);
    },
    handleChooseTab(idx) {
      if (this.currIdx === idx) {
        this.dropDownList[idx - 1].active = !this.dropDownList[idx - 1].active;
        return;
      }
      this.lastIdx = this.currIdx;
      this.currIdx = idx;
      this.dropDownList[idx - 1].active = true;
      this.dropDownList[this.lastIdx - 1].active = false;
    },
    otherLoad() {
      this.otherLoaded = true;
    },
    todeskLoad() {
      this.todeskLoaded = true;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.game_version_mb {
  width: 100%;
  height: 100%;
  * {
    box-sizing: border-box;
  }
  .main_wrap {
    width: 100%;
    height: 100%;
    background-color: #212121;
    .mb_head_2k {
      width: 100%;
      height: auto;
      padding-top: 266px;
      background-size: auto 430px;
      background-position: top center;
      background-repeat: no-repeat;
      background-image: url("https://todeskcdnspeed.todesk.com/202305051654385faee7063b19d8.png");
      .head_btn_wrap {
        display: flex;
        justify-content: space-between;
        width: 276.53px;
        margin: 0 auto;
        .head_dl_btn,
        .head_by_btn {
          display: block;
          width: 122.13px;
          height: 40px;
        }
      }
      .block_2k_wrap {
        .block_2k_title {
          width: 143px;
          height: 66px;
          margin: 94px auto 0;
          background-size: auto 56.664px;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("https://todeskcdnspeed.todesk.com/202305051717395faeec2b8888b8.png");
        }
        .block_2k_desc {
          width: 331px;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 173.19%;
          text-align: center;
          color: #ced0d4;
          margin: 6px auto 0;
        }
        .block_2k_pic_wrap {
          width: 335px;
          height: 248.61px;
          margin: 35px auto 0;
          background-size: auto 187.5px;
          background-position: top center;
          background-repeat: no-repeat;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081024315fb2556bfa9d8c.png");
          .trans_line {
            width: 350px;
            height: 100%;
            overflow: hidden;
            display: flex;
            align-items: flex-end;
            &.animation {
              animation: trans_line_anim 2s linear;
            }
            .line_img {
              width: 335px;
              height: auto;
              display: block;
            }
            @keyframes trans_line_anim {
              0% {
                width: 0%;
              }
              50% {
                width: 50%;
              }
              100% {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .mb_3d_wrap {
      margin-top: 70.39px;
      .block_3d_title {
        width: 176px;
        height: 66px;
        margin: 0 auto;
        background-size: auto 56.664px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("https://todeskcdnspeed.todesk.com/202305051933415faf0a937da84c.png");
      }
      .block_3d_desc {
        width: 331px;
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 173.19%;
        text-align: center;
        color: #ced0d4;
        margin: 6px auto 0;
      }
      .vdo_vs_wrap {
        width: 335px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
        .vdo_other_wrap,
        .vdo_todesk_wrap {
          width: 161px;
          height: 130px;
          border-radius: 9.53737px;
          overflow: hidden;
          margin-top: 30px;
          display: flex;
          flex-direction: column;
          video {
            width: 161px;
            height: auto;
            object-fit: cover;
          }
        }
        .vdo_other_wrap {
          border: 1px solid #d9d9d9;
          margin-right: 13px;
          p {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #828282;
            border-radius: 0 0 9.53737px 9.53737px;
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
        }
        .vdo_todesk_wrap {
          border: 1px solid #ffd7b2;
          p {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #59554d;
            border-radius: 0 0 9.53737px 9.53737px;
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 14px;
            color: #ffd7b2;
          }
        }
        .vdo_vs {
          width: 99px;
          height: 99px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
          img {
            width: 99px;
            height: 99px;
            display: block;
          }
        }
      }
      .block_desc_warp {
        margin-top: 14px;
        .mouse_wrap,
        .handler_wrap {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          .desc_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            letter-spacing: 0.5px;
            color: #ffffff;
          }
          .desc_text {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 130%;
            letter-spacing: 0.5px;
            color: #ced0d4;
            margin-top: 6px;
          }
        }
        .mouse_wrap {
          width: 100%;
          height: 305px;
          background-size: 160px auto;
          background-repeat: no-repeat;
          background-position: top left;
          background-image: url("https://todeskcdnspeed.todesk.com/202305061936495fb04d24878060.png");
          .bg_wrap {
            width: 335px;
            height: 271px;
            margin: 0 auto;
            background-size: 335px auto;
            background-repeat: no-repeat;
            background-position: top;
            background-image: url("https://todeskcdnspeed.todesk.com/202305061750385fb0356842f4d0.png");
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
        .handler_wrap {
          width: 100%;
          height: 305px;
          background-size: 270px auto;
          background-repeat: no-repeat;
          background-position: top left;
          background-image: url("https://todeskcdnspeed.todesk.com/202305061937205fb04d421ff7c4.png");
          .bg_wrap {
            width: 335px;
            height: 262px;
            margin: 0 auto;
            background-size: 335px auto;
            background-repeat: no-repeat;
            background-position: top;
            background-image: url("https://todeskcdnspeed.todesk.com/202305061750485fb0357167569c.png");
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
      }
      .block_kb_wrap {
        width: 100%;
        margin-top: 91px;
        background-size: 375px auto;
        background-position: top center;
        background-repeat: no-repeat;
        background-image: url("https://todeskcdnspeed.todesk.com/202305081052295fb25bac74dbb4.png");
        position: relative;
        z-index: 1;
        .block_kb_title {
          width: 240px;
          height: 66px;
          margin: 0 auto;
          background-size: auto 56.664px;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081052125fb25b9c996b24.png");
        }
        .block_kb_desc {
          width: 335px;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 173.19%;
          text-align: center;
          color: #ced0d4;
          margin: 6px auto 0;
        }
        .drop_down_wrap {
          margin-top: 20px;
          .drop_down_item {
            width: 335px;
            min-height: 54px;
            padding: 15px 0;
            background-color: #0c0c0c;
            border-radius: 6px;
            overflow: hidden;
            margin: 10px auto 0;
            &:first-of-type {
              margin-top: 20px;
            }
            &.active {
              .drop_down_head > .dd_arrow {
                transform: rotate(-180deg);
              }
              .drop_down_img {
                height: 175px;
                opacity: 1;
              }
            }
            &_1 {
              .dd_label {
                background-size: auto 24px;
                background-position: 18px center;
                background-image: url("~@/assets/game/icon-lol.png");
              }
            }
            &_2 {
              .dd_label {
                background-size: auto 18px;
                background-position: 17px center;
                background-image: url("~@/assets/game/icon-pubg.png");
              }
            }
            &_3 {
              .dd_label {
                background-size: auto 24px;
                background-position: 18px center;
                background-image: url("~@/assets/game/icon-toc.png");
              }
            }
            &_4 {
              .dd_label {
                background-size: auto 24px;
                background-position: 10px center;
                background-image: url("~@/assets/game/icon-dnf.png");
              }
            }
            &_5 {
              .dd_label {
                background-size: auto 13.71px;
                background-position: 16px center;
                background-image: url("~@/assets/game/icon-speed.png");
              }
            }
            &_6 {
              .dd_label {
                background-size: auto 9.38px;
                background-position: 16px center;
                background-image: url("~@/assets/game/icon-bound.png");
              }
            }
            .drop_down_head {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .dd_label {
                padding-left: 48.86px;
                font-family: "PingFang SC";
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                color: #ffffff;
                background-repeat: no-repeat;
              }
              .dd_arrow {
                margin-right: 20px;
                width: 16px;
                height: 16px;
                background-size: 16px 16px;
                background-repeat: no-repeat;
                background-image: url("~@/assets/game/arrow-down.png");
                transform: rotate(-0);
                transition: transform 0.3s;
              }
            }
            .drop_down_img {
              width: 295px;
              height: 0;
              opacity: 0;
              margin: 0 auto;
              transition: height 0.3s, opacity 0.5s;
              overflow: hidden;
              img {
                margin-top: 14px;
                width: 295px;
                height: auto;
                display: block;
              }
            }
          }
        }
      }
      .block_fun_wrap {
        margin-top: 60.39px;
        position: relative;
        .fun_bg_wrap {
          z-index: 0;
          position: absolute;
          top: -320px;
          width: 375px;
          height: 960px;
          background-size: 375px auto;
          background-position: top center;
          background-repeat: no-repeat;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081214165fb26df47a482c.png");
        }
        .fun_item {
          position: relative;
          z-index: 1;
          margin-bottom: 40px;
          &:last-of-type {
            margin-bottom: 0;
          }
          img {
            width: 355px;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .fun_title {
            font-family: "PingFang SC";
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            letter-spacing: 0.5px;
            color: #ffffff;
            padding: 0 20px;
          }
          .fun_desc {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 130%;
            letter-spacing: 0.5px;
            color: #ced0d4;
            margin-top: 6px;
            padding: 0 20px;
          }
        }
      }
      .config_require_wrap {
        width: 335px;
        height: 298px;
        margin: 70px auto 0;
        background-color: rgba(0, 0, 0, 0.6);
        border: 0.2794px solid #ffd7b2;
        border-radius: 1.6764px;
        padding-top: 38px;
        .rq_title {
          width: 210px;
          height: 28px;
          margin: 0 auto 45px;
          background-repeat: no-repeat;
          background-size: auto 23.333px;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081428015fb28bd9012ea8.png");
        }
        .rq_detail_wrap {
          display: flex;
          padding: 0 18px 0 20px;
          .rq_label {
            width: 63px;
            font-family: "Roboto";
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #9e9e9f;
          }
          .rq_text_wrap {
            margin-bottom: 20px;
            .rq_text {
              font-family: "Roboto";
              font-weight: 400;
              font-size: 13px;
              line-height: 15px;
              color: #ffffff;
            }
            .rq_text + .rq_text {
              margin-top: 2px;
            }
          }
        }
      }
      .gv_dl_wrap {
        position: relative;
        margin-top: 70px;
        width: 375px;
        height: 256px;
        padding-top: 38px;
        background-size: 375px auto;
        background-repeat: no-repeat;
        background-image: url("https://todeskcdnspeed.todesk.com/202305081459545fb292f9f97f94.png");
        .gv_dl_title {
          width: 153px;
          height: 28px;
          margin: 0 auto 6px;
          background-repeat: no-repeat;
          background-size: auto 23.333px;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081428175fb28be903f344.png");
        }
        .dl_desc1 {
          font-family: "Roboto";
          font-weight: 400;
          font-size: 14px;
          line-height: 145.19%;
          text-align: center;
          color: #ffffff;
        }
        .dl_desc2 {
          font-family: "Roboto";
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          letter-spacing: 1px;
          color: #9e9e9f;
          margin-top: 14px;
        }
        .gv_btn_wrap {
          width: 276.53px;
          height: 40px;
          margin: 40px auto 0;
          display: flex;
          justify-content: space-between;
          background-image: url("https://todeskcdnspeed.todesk.com/202305081452165fb29144ca79d0.png");
          background-repeat: no-repeat;
          background-size: auto 40px;
          .head_dl_btn,
          .head_by_btn {
            position: relative;
            z-index: 1;
            display: block;
            width: 122.13px;
            height: 40px;
          }
        }
      }
    }
  }
}
</style>
